import React, {useEffect, useRef, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {ModeleRechercheCatalogue, modeleRechercheCatalugeValues} from '../../../components/Models'
import * as Yup from 'yup'
import {
  getAllPieceTypePiece,
  getCatalogues,
  getMarqueVehicule,
  getModeleVehicule,
  getSearchPieceTypePiece,
  searchCatalog,
  exportCatalogue,
} from '../../../components/requests'
import {useFormik} from 'formik'
import {TextInput} from '../../../components/inputs/TextInput'
import {SelectInput} from '../../../components/inputs/SelectInput'
import {toast, ToastContainer} from 'react-toastify'
import {DetailsModal} from '../catalogues/components/DetailsModal'
import Select from 'react-select'
import {SearchPiece} from '../../../components/SearchPiece'
import {Tooltip} from 'react-tooltip'

const rechercheCatalogueSchema = Yup.object().shape({
  catalogue: Yup.string().required('Ce champs est réquis.'),
  referenceConstructeur: Yup.string().notRequired(),
  referenceVehicule: Yup.string().notRequired(),
  referencePiece: Yup.string().notRequired(),
  prixVenteMin: Yup.number().min(0, 'La valeur minimale requise est 0').notRequired(),
  prixVenteMax: Yup.number().min(0, 'La valeur minimale requise est 0').notRequired(),
})

const RechercheCataloguePage = () => {
  let {catalogue, referenceConstructeur, referenceVehicule, referencePiece} = useParams()
  const [data, setData] = useState<ModeleRechercheCatalogue>(modeleRechercheCatalugeValues)
  const [resultData, setResultData] = useState<any | undefined>([])
  const [optionsCatalogue, setOptionsCatalogue] = useState<any | undefined>([])
  const [loading, setLoading] = useState(false)
  const [noExistingCatalog, setNoExistingCatalog] = useState(false)
  const [dataFiltered, setDataFiltered] = useState<any>([])
  const [allMarqueVehicule, setAllMarqueVehicule] = useState<any | undefined>([])
  const [allModeleVehicule, setAllModeleVehicule] = useState<any | undefined>([])
  const [marqueVehicule, setMarqueVehicule] = useState<any | undefined>([])
  const [modeleVehicule, setModeleVehicule] = useState<any | undefined>([])
  const [valueMarque, setValueMarque] = useState<any>([])
  const [valueModele, setValueModele] = useState<any>([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [clearInput, setClearInput] = useState<boolean>(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [suggestion, setSuggestion] = useState<Array<string>>([])
  const [match, setMatch] = useState<Array<string> | null>([])
  const [pieceSpinner, setPieceSpinner] = useState<boolean>(false)
  const [resultShowPiece, setResultShowPiece] = useState<boolean>(false)
  const [pieceTypePiece, setPieceTypePiece] = useState<string>('')
  const [valueTypePieces, setValueTypePieces] = useState<any>([])
  const [isDownload, setIsDownload] = useState<boolean>(false)
  const [isXls, setIsXls] = useState<boolean>(false)
  const [isCsv, setIsCsv] = useState<boolean>(false)

  const API_URL = process.env.REACT_APP_API_URL
  const exportUrl = `${API_URL}/export/catalogues`

  // Récupération des options sur le type pièces
  const getTypePiecesData = () => {
    getAllPieceTypePiece()
      .then((typePiecesRequest) => {
        if (typePiecesRequest?.status === 200 && typePiecesRequest?.data) {
          setSuggestion(typePiecesRequest?.data)
        }
      })
      .catch((e) => {
        console.error('Error')
      })
  }

  // Récupération les marques de vehicules
  const getMarqueVehiculeData = () => {
    getMarqueVehicule()
      .then((marqueRequest) => {
        if (marqueRequest?.status === 200) {
          if (marqueRequest?.data !== undefined) {
            const transformedData = marqueRequest.data.map((item) => ({
              marque: item.id,
              value: item.nom,
              label: item.nom,
            }))
            setAllMarqueVehicule([...transformedData])
            setMarqueVehicule([...transformedData])
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  // Récupération les modeles de vehicules
  const getModeleVehiculeData = () => {
    getModeleVehicule()
      .then((modeleRequest) => {
        if (modeleRequest?.status === 200) {
          if (modeleRequest?.data !== undefined) {
            const transformedData = modeleRequest.data.map((item) => ({
              marque: item.idMarque,
              value: item.nom,
              label: item.nom,
            }))
            setAllModeleVehicule([...transformedData])
            setModeleVehicule([...transformedData])
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const handleMarqueChange = async (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueMarque([])
      setModeleVehicule(allModeleVehicule)
      formik.setFieldValue('marque', '')
    } else {
      // definir la valeur choisi de marque
      setValueMarque(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const marques = data
        ? data
            .map((marque) => marque.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('marque', marques.toString())
    }
  }

  const handleModeleChange = async (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueModele([])
      formik.setFieldValue('modele', '')
    } else {
      // definir la valeur choisi de modele
      setValueModele(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const modeles = data
        ? data
            .map((modele) => modele.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('modele', modeles)
    }
  }

  // Autocompletion de la suggestion en appuyant sur Tab ou sur Entrer
  const autocompleteOnKeyDown = (e) => {
    if (
      (e.code === 'Tab' || e.code === 'Enter' || e.code === 'ArrowRight') &&
      match &&
      match.length !== 0
    ) {
      e.preventDefault()
      e.target.value = match.join('').toLowerCase()
      searchPieceTypePiece(e.target.value)
      setMatch([])
    }
  }

  // Méthode de recherche du nom ou code nomenclature du type pièce
  function searchTypePiece(value) {
    timeoutRef.current = setTimeout(() => {
      if (value !== '') {
        setPieceSpinner(true)
        getSearchPieceTypePiece(value, true)
          .then((res) => {
            if (res?.status === 200 && res?.data) {
              setResultShowPiece(true)
              setPieceTypePiece(res.data)
            } else {
              setResultShowPiece(false)
              setPieceTypePiece('')
            }
          })
          .catch(() => {
            console.log('error')
          })
          .finally(() => {
            setPieceSpinner(false)
          })
      }
    }, 1000)
  }

  // gestion recherche de pièce par type pièce
  const searchPieceTypePiece = (inputValue) => {
    setSearchValue(inputValue)
    setClearInput(false)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    // Traitement du nom tappé dans le formulaire et enregistrement de la suggestion
    if (inputValue !== '' && inputValue !== null) {
      const matchingValue = String(
        suggestion.find((name) => name.toLowerCase().startsWith(inputValue.toLowerCase()))
      ).toLowerCase()
      if (matchingValue !== 'undefined' && matchingValue !== null) {
        const prefix = inputValue
        const suffix = matchingValue.slice(inputValue.length)
        setMatch([prefix, suffix])
      } else {
        setMatch([])
      }
    } else {
      setMatch([])
    }

    searchTypePiece(inputValue)
  }

  // Méthode de suppression d'un type pièce séléctionné
  const handleRemovetypePiece = (idToRemove: number) => {
    const updated = valueTypePieces.filter((p) => p.id !== idToRemove)
    setValueTypePieces(updated)
    if (idToRemove === null) formik.setFieldValue('typePieceHn', '')
    formik.setFieldValue('typePieces', updated.map((p) => p.id).join(','))
  }

  // filtrer les données de modèle apres selection de marque
  useEffect(() => {
    if (valueMarque.length > 0 && allModeleVehicule.length > 0) {
      const filteredModele = allModeleVehicule.filter((vehicule) =>
        valueMarque.some((item) => vehicule?.marque === item.marque)
      )
      setModeleVehicule(filteredModele)
    }
  }, [valueMarque, allMarqueVehicule, allModeleVehicule])

  useEffect(() => {
    getCatalogues()
      .then((rolesRequest) => {
        if (rolesRequest?.status === 200) {
          if (rolesRequest?.data !== undefined) {
            const optionsCatal = rolesRequest?.data?.map((item) => ({
              value: item.id,
              label: item.nom,
            }))

            setOptionsCatalogue(optionsCatal)
          }
        } else {
          setLoading(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
    getMarqueVehiculeData()
    getModeleVehiculeData()
    getTypePiecesData()
  }, [])

  useEffect(() => {
    if (
      data.referenceConstructeur ||
      data.referenceVehicule ||
      data.referencePiece ||
      data.prixVenteMin ||
      data.prixVenteMax ||
      data.marque ||
      data.modele ||
      data.codeMoteur ||
      data.typePieces
    ) {
      setLoading(true)
      setNoExistingCatalog(false)
      submitForm(data)
    }
  }, [data])

  /* useEffect(() => {
    if (catalogue ) {
      formik.setFieldValue("catalogue",catalogue);
      if(referenceConstructeur){
        formik.setFieldValue("referenceConstructeur", referenceConstructeur);
      }

      if(referenceVehicule){
        formik.setFieldValue("referenceVehicule", referenceVehicule);
      }
      if(referencePiece){
        formik.setFieldValue("referencePiece", referencePiece);
      }

      const updatedData = Object.assign({...data}, {catalogue,referenceConstructeur,referenceVehicule,referencePiece})

      setData(updatedData);
    }
  }, [catalogue,referenceConstructeur,referenceVehicule,referencePiece]); */

  const formik = useFormik<ModeleRechercheCatalogue>({
    initialValues: data,
    validationSchema: rechercheCatalogueSchema,
    onSubmit: (values: ModeleRechercheCatalogue): void => {
      if (
        values.referenceConstructeur === '' &&
        values.referenceVehicule === '' &&
        values.referencePiece === '' &&
        values.prixVenteMin === '' &&
        values.prixVenteMax === '' &&
        values.marque === '' &&
        values.modele === '' &&
        values.codeMoteur === '' &&
        values.typePieces === ''
      ) {
        toast.error("Veuillez compléter la recherche avec l'un des filtres !", {
          autoClose: 7000,
        })
        return
      }
      setTimeout(() => {
        const updatedData: ModeleRechercheCatalogue = Object.assign({...data}, values)
        setData(updatedData)
        // submitForm(updatedData)
      }, 200)
    },
    validateOnChange: false,
    validateOnBlur: true, //
  })

  const submitForm = async (d: ModeleRechercheCatalogue = {}) => {
    setLoading(true)
    try {
      searchCatalog(d).then((requestResponse) => {
        if (requestResponse?.status === 200) {
          if (requestResponse?.data !== undefined) {
            if (requestResponse?.data?.cataloguePieces?.length === 0) {
              setNoExistingCatalog(true)
            }

            setResultData(requestResponse?.data)
            setLoading(false)
          }
        }
      })
    } catch (ex) {
      console.error(ex)
      setLoading(false)
    }
  }

  const showDetail = (cat: any) => {
    setDataFiltered(cat)
  }

  // Style du select pour les filtres marque et modèle
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
      backgroundColor: 'transparent',
    }),
  }

  const exportData = async (type) => {
    if (resultData?.length !== 0 && resultData?.cataloguePieces?.length !== 0) {
      setIsDownload(true)
      try {
        exportCatalogue(type, resultData?.cataloguePieces).then((requestResponse) => {
          if (requestResponse?.status === 200) {
            if (requestResponse?.data !== undefined) {
              let urlUpload = exportUrl + '/' + requestResponse?.data?.url

              // Créer un lien de téléchargement temporaire
              const link = document.createElement('a')
              link.href = urlUpload
              link.download = requestResponse?.data?.url // Nom du fichier téléchargé
              document.body.appendChild(link)
              link.click() // Clique sur le lien pour démarrer le téléchargement
              document.body.removeChild(link)
              setIsDownload(false)
            }
          }
        })
      } catch (ex) {
        console.error(ex)
        setIsDownload(false)
      }
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Recherche</h3>
          </div>
        </div>

        <div>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row mb-6'>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className=' col-form-label fw-bold fs-6'>Catalogues</label>
                  <SelectInput
                    fieldName={'catalogue'}
                    inputPlaceholder={'Modèles de catalogue'}
                    inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                    options={optionsCatalogue}
                    formik={formik}
                  />
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className='col-form-label fw-bold fs-6'>Par référence constructeur</label>
                  <TextInput
                    fieldName={'referenceConstructeur'}
                    inputPlaceholder={'Référence constructeur'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>

                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className=' col-form-label fw-bold fs-6'>Par référence véhicule</label>
                  <TextInput
                    fieldName={'referenceVehicule'}
                    inputPlaceholder={'Référence véhicule'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className='col-form-label fw-bold fs-6'>Par référence de pièce</label>
                  <TextInput
                    fieldName={'referencePiece'}
                    inputPlaceholder={'Référence de pièce'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>

                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className=' col-form-label fw-bold fs-6'>Prix de vente min (€ HT)</label>
                  <input
                    type='number'
                    min='0'
                    name='prixVenteMin'
                    placeholder='Minimum'
                    value={formik.values.prixVenteMin}
                    onChange={formik.handleChange}
                    onKeyDown={(e) =>
                      e.key.length === 1 && !/[0-9.*axcv]/.test(e.key) ? e.preventDefault() : null
                    }
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  />
                  {formik.errors.prixVenteMin ? (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.prixVenteMin}</div>
                    </div>
                  ) : null}
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className=' col-form-label fw-bold fs-6'>Prix de vente max (€ HT)</label>
                  <input
                    type='number'
                    min='0'
                    name='prixVenteMax'
                    placeholder='Maximum'
                    value={formik.values.prixVenteMax}
                    onChange={formik.handleChange}
                    onKeyDown={(e) =>
                      e.key.length === 1 && !/[0-9.*axcv]/.test(e.key) ? e.preventDefault() : null
                    }
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  />
                  {formik.errors.prixVenteMax ? (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.prixVenteMax}</div>
                    </div>
                  ) : null}
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className=' col-form-label fw-bold fs-6'>Par marque</label>
                  <Select
                    styles={customStyles}
                    className='react-select-styled react-select-solid react-select-lg'
                    classNamePrefix='react-select'
                    options={marqueVehicule}
                    value={valueMarque}
                    placeholder='Marque'
                    isDisabled={marqueVehicule.length === 0}
                    isLoading={marqueVehicule.length === 0}
                    isClearable
                    isMulti
                    onChange={(data) => handleMarqueChange(data)}
                  />
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className='col-form-label fw-bold fs-6'>Par modèle</label>
                  <Select
                    styles={customStyles}
                    className='react-select-styled react-select-solid react-select-lg'
                    classNamePrefix='react-select'
                    options={modeleVehicule}
                    value={valueModele}
                    placeholder='Modèle'
                    isDisabled={marqueVehicule.length === 0}
                    isLoading={marqueVehicule.length === 0}
                    isClearable
                    isMulti
                    onChange={(data) => handleModeleChange(data)}
                  />
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className=' col-form-label fw-bold fs-6'>Par code moteur</label>
                  <TextInput
                    fieldName={'codeMoteur'}
                    inputPlaceholder={'Code moteur'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
                <div className='col-lg-3 col-md-4 col-sm-6 fv-row'>
                  <label className='col-form-label fw-bold fs-6'>
                    Code nomenclature / type de pièce
                  </label>
                  <SearchPiece
                    inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                    placeholder={'Code nomenclature / Type pièce'}
                    onChange={(e) => searchPieceTypePiece(e.target.value)}
                    onKeyDown={(e) => autocompleteOnKeyDown(e)}
                    resultatPiece={pieceTypePiece}
                    value={searchValue}
                    match={match}
                    setMatch={setMatch}
                    setSearchValue={setSearchValue}
                    pieceSpinner={pieceSpinner}
                    resultShowPiece={resultShowPiece}
                    clearInput={clearInput}
                    selectedSearchValue=''
                    showPieceHn={false}
                    onSelect={(selectedPiece) => {
                      if (!valueTypePieces.some((p) => p.id === selectedPiece.id)) {
                        const updated = [...valueTypePieces, selectedPiece]
                        setValueTypePieces(updated)
                        const typePieces = updated
                          .filter((p) => p.id !== null && p.id !== '')
                          .map((p) => p.id)
                          .join(',')
                        formik.setFieldValue('typePieces', typePieces)
                      } else {
                        toast.error('Pièce déjà ajoutée dans la liste', {autoClose: 4000})
                      }
                      setClearInput(true)
                      setSearchValue('')
                      setMatch([]) // Nettoyage du champ d'autocompletion après la selection
                    }}
                  />
                </div>
                <div className='col-lg-6 col-md-8 col-sm-12 fv-row'>
                  <label className='col-form-label fw-bold fs-6'>
                    Type(s) de pièce(s) sélectionné(s)
                  </label>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'flex-start',
                      minHeight: '45px',
                      maxHeight: '120px',
                      overflowY: 'auto',
                      border: '1px solid #ccc',
                      borderRadius: '6px',
                      backgroundColor: '#f9f9f9',
                      cursor: 'text',
                    }}
                  >
                    {valueTypePieces.length > 0
                      ? valueTypePieces.map((valueTypePiece) => (
                          <div
                            key={valueTypePiece.id}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: '#e7f3ff',
                              color: '#0d6efd',
                              borderRadius: '16px',
                              padding: '4px 10px',
                              margin: '4px',
                              fontSize: '14px',
                            }}
                          >
                            {valueTypePiece?.isHorNom && valueTypePiece?.id === null && '[99999]'}{' '}
                            {valueTypePiece.nom}
                            <button
                              type='button'
                              onClick={() => handleRemovetypePiece(valueTypePiece.id)}
                              style={{
                                background: 'none',
                                border: 'none',
                                color: '#0d6efd',
                                fontWeight: 'bold',
                                marginLeft: '8px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                lineHeight: '1',
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button
                type='submit'
                className='btn btn-primary'
                disabled={
                  loading ||
                  !!(formik.values.referencePiece && formik.values.referencePiece.length < 6)
                }
              >
                {!loading && 'Rechercher'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Recherche...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {noExistingCatalog && (
        <div>
          <div className='row g-5 g-xl-8'>
            {/* begin::Col  */}
            <div className='col-xxl-12'>
              <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
                <div className='card-body py-3'>
                  <p className={'text-danger mt-4'}>Aucune pièce trouvée...</p>
                </div>
              </div>
            </div>
            {/* end::Col  */}
          </div>
        </div>
      )}

      {resultData?.length !== 0 && resultData?.cataloguePieces?.length !== 0 && (
        <div>
          <div className='row g-5 g-xl-8'>
            {/* begin::Col  */}
            <div className='col-xxl-12'>
              <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Pièces</span>
                  </h3>
                </div>
                <div className='d-flex justify-content-end py-6 px-9 gap-2'>
                  <button
                    className='btn btn-primary btn-sm'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Export csv'
                    data-tooltip-place='top'
                    disabled={isDownload}
                    onClick={() => {
                      setIsCsv(true)
                      setIsXls(false)
                      exportData('csv')
                    }}
                  >
                    {isCsv && isDownload ? (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Export en cours......{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      'Exporter CSV'
                    )}
                  </button>

                  <button
                    className='btn btn-primary btn-sm'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Export xls'
                    data-tooltip-place='top'
                    disabled={isDownload}
                    onClick={() => {
                      setIsXls(true)
                      setIsCsv(false)
                      exportData('xls')
                    }}
                  >
                    {isXls && isDownload ? (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Export en cours......{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      'Exporter XLS'
                    )}
                  </button>
                </div>
                {/* end::Header */}
                <div className='card-body py-3'>
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='min-w-140px'>Code Produit</th>
                          <th className='min-w-140px'>Code NE</th>
                          <th className='min-w-140px'>Réf Constructeur</th>
                          <th className='min-w-140px'>Type de pièce</th>
                          <th className='min-w-140px'>Catégorie</th>
                          <th className='min-w-140px'>Sous-catégorie</th>
                          <th className='min-w-140px'>Véhicule Origine</th>
                          <th className='min-w-140px'>Modèle</th>
                          <th className='min-w-140px'>VIN</th>
                          <th className='min-w-140px'>Année</th>
                          <th className='min-w-140px'>Km</th>
                          <th className='min-w-140px'>Tarif (€ HT)</th>
                          <th className='min-w-140px'>Site</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {resultData?.cataloguePieces?.map((catalogue, i) => {
                          return (
                            <tr
                              key={i}
                              data-bs-target='#modal_details_cat'
                              data-bs-toggle='modal'
                              data-bs-dismiss='modal'
                              onClick={() => showDetail(catalogue)}
                            >
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.code}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.vehiculeEntre?.numero}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.piece?.referenceConstructeur}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.piece?.typePiece?.nom}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.piece?.typePiece?.sousCategorie?.categorie?.nom}
                                </p>
                              </td>

                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.piece?.typePiece?.sousCategorie?.nom +
                                    ` (` +
                                    catalogue?.piece?.typePiece?.sousCategorie?.code +
                                    `)`}
                                </p>
                              </td>

                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.vehiculeEntre?.vehicule?.modele?.marque?.nom}
                                </p>
                              </td>

                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.vehiculeEntre?.vehicule?.modele?.nom}
                                </p>
                              </td>

                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.vehiculeEntre?.vin?.toUpperCase()}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.vehiculeEntre?.annee}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.vehiculeEntre?.km}
                                </p>
                              </td>

                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.prix}
                                </p>
                              </td>
                              <td>
                                <p
                                  className={`text-dark d-block text-hover-primary cursor-pointer fs-6 mb-0`}
                                >
                                  {catalogue?.site?.code}
                                </p>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                  {/* end::Table container */}
                </div>
              </div>
            </div>
            {/* end::Col  */}
          </div>
        </div>
      )}
      <Tooltip id='tooltip' />
      <DetailsModal data={dataFiltered} />
    </>
  )
}

export {RechercheCataloguePage}
